import React from 'react';
import StarRate from 'components/Core/StarRate';
import WebsiteImage from 'components/WebsiteImage';
import { heroReviews } from 'components/Contentful/ContentfulDynamicHero/utils/heroReviews';
import useDynamicHeroImages from 'hooks/useDynamicHeroImages';

import { Container } from './styles';

const SimpleSocialProofSection = ({ theme }) => {
  const reviews = heroReviews(useDynamicHeroImages(), theme === 'light' ? 'Black' : 'White');
  const { stars, starColor, starOffColor, title, companyLogos } = reviews;
  const correctOrder = ['Google', 'Capterra', 'Advice']; // Google, capterra, software advice
  const orderIndex = (internalName) => correctOrder.findIndex((val) => internalName.includes(val));
  companyLogos.sort((a, b) => orderIndex(a.internalName) - orderIndex(b.internalName));

  return (
    <Container className="simple-social-proof-section--container" theme={theme}>
      <div className="simple-social-proof-section--content">
        <StarRate
          value={stars}
          starRendererProps={{
            colorActive: starColor,
            colorInactive: starOffColor,
          }}
        />
        <p className="simple-social-proof-section--description">{title}</p>
      </div>

      <div className="simple-social-proof-section--logo-content">
        {companyLogos.map((item, index) => {
          return (
            <div className="simple-social-proof-section--logo-item" key={index}>
              <WebsiteImage loading="eager" image={item} />
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default SimpleSocialProofSection;
